export const STANDARD_FONT_WEIGHTS = [100, 200, 300, 400, 500, 600, 700, 800, 900] as const;

export function fontWeightName(weight: number): string {
  switch (weight) {
    case 100:
      return "Thin";
    case 200:
      return "Extra Light";
    case 300:
      return "Light";
    case 400:
      return "Regular";
    case 500:
      return "Medium";
    case 600:
      return "Semi Bold";
    case 700:
      return "Bold";
    case 800:
      return "Extra Bold";
    case 900:
      return "Black";
    default:
      return "Regular";
  }
}

export function pickNearestFontWeight(weight: number, available: number[]): number {
  if (available.length === 0) {
    return 400;
  }
  if (available.includes(weight)) {
    return weight;
  }
  return available.reduce((best, candidate) =>
    Math.abs(candidate - weight) < Math.abs(best - weight) ? candidate : best, available[0]!);
}

export function pickDefaultFontWeight(available: number[]): number {
  if (available.length === 0) {
    return 400;
  }
  return available.find(weight => weight >= 400) ?? available[0]!;
}
